(function (angular, app) {
    'use strict';

    app.directive('spSeoCategories', ['Config', '$state', '$filter', function (Config, $state, $filter) {
        return {
            restrict: 'E',
            replace: true,
            template: '<nav class="seo-categories" aria-hidden="true" style="position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0">' +
                '<a ng-repeat="link in seoLinks track by link.id" ng-href="{{::link.url}}">{{::link.name}}</a>' +
                '</nav>',
            link: function (scope) {
                var nameFilter = $filter('name');

                Config.initPromise.then(function () {
                    if (!Config.tree || !Config.tree.categories) {
                        return;
                    }

                    var links = [];
                    angular.forEach(Config.tree.categories, function (category) {
                        if (category.bySpecialCategories) {
                            return;
                        }
                        _addCategoryLinks(links, category, nameFilter);
                    });

                    scope.seoLinks = links;
                });

                function _addCategoryLinks(links, category, nameFilter) {
                    var subs = category.subCategories;
                    if (!subs || !subs.length) {
                        links.push({
                            id: category.id,
                            url: $state.href('app.categoryProducts', {cid: category.id, filters: undefined, sort: undefined}),
                            name: nameFilter(category.names)
                        });
                        return;
                    }

                    for (var i = 0; i < subs.length; i++) {
                        links.push({
                            id: subs[i].id,
                            url: $state.href('app.categoryProducts', {cid: subs[i].id, filters: undefined, sort: undefined}),
                            name: nameFilter(subs[i].names)
                        });

                        var subSubs = subs[i].subCategories;
                        if (subSubs && subSubs.length) {
                            for (var j = 0; j < subSubs.length; j++) {
                                links.push({
                                    id: subSubs[j].id,
                                    url: $state.href('app.categoryProducts', {cid: subSubs[j].id, filters: undefined, sort: undefined}),
                                    name: nameFilter(subSubs[j].names)
                                });
                            }
                        }
                    }
                }
            }
        };
    }]);
})(angular, app);
